(function(){
  'use strict';

  /* ── REVEAL (.rev → .on) ── */
  if('IntersectionObserver' in window){
    var ro = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('on');
          ro.unobserve(e.target);
        }
      });
    },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.rev').forEach(function(el){ro.observe(el);});
  } else {
    document.querySelectorAll('.rev').forEach(function(el){el.classList.add('on');});
  }

  /* ── FAQ ACCORDÉON (.vp-fi) ── */
  document.querySelectorAll('.vp-fb-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item = btn.closest('.vp-fi');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.vp-fi.open').forEach(function(i){ i.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });

  /* ── ACCORDÉON PRODUIT (.epv-acc-item) ── */
  document.querySelectorAll('.epv-acc-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item = btn.closest('.epv-acc-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.epv-acc-item.open').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.epv-acc-btn').setAttribute('aria-expanded','false');
      });
      if(!wasOpen){
        item.classList.add('open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  /* ── SLIDER PHOTOS PRODUIT (.epv-slider-track) ── */
  var track = document.getElementById('epv-track');
  if(track){
    var slides = track.querySelectorAll('.epv-slide');
    var dots   = document.querySelectorAll('.epv-dot');
    var prev   = document.querySelector('.epv-arrow--prev');
    var next   = document.querySelector('.epv-arrow--next');
    var n      = slides.length;
    var cur    = 0;
    function goTo(i){
      cur = (i + n) % n;
      track.scrollTo({left: cur * track.offsetWidth, behavior:'smooth'});
      dots.forEach(function(d,k){ d.classList.toggle('active', k === cur); });
    }
    if(prev) prev.addEventListener('click',function(){ goTo(cur - 1); });
    if(next) next.addEventListener('click',function(){ goTo(cur + 1); });
    dots.forEach(function(d,i){ d.addEventListener('click',function(){ goTo(i); }); });
    /* Swipe */
    var sx = null;
    track.addEventListener('touchstart',function(e){ sx = e.touches[0].clientX; },{passive:true});
    track.addEventListener('touchend',function(e){
      if(sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
      sx = null;
    },{passive:true});
  }

  /* ── CAROUSEL AVIS PRODUIT (.epv-avis-track) ── */
  var avisTrack = document.getElementById('epv-avis-track');
  if(avisTrack){
    var avisItems = avisTrack.querySelectorAll('.epv-avis-item');
    var na = avisItems.length;
    var ca = 0;
    var autoAvis = setInterval(function(){
      ca = (ca + 1) % na;
      avisTrack.scrollTo({left: ca * avisTrack.offsetWidth, behavior:'smooth'});
    }, 4000);
    /* Pause on touch */
    avisTrack.addEventListener('touchstart',function(){ clearInterval(autoAvis); },{passive:true,once:true});
  }

  /* ── DELIVERY TIMER (fallback si pas inline) ── */
  var dEl = document.getElementById('vp-date-livr');
  if(dEl && !dEl.textContent.trim()){
    var now = new Date();
    var jours  = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    var mois   = ['jan.','fév.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
    var d = new Date(now);
    d.setDate(d.getDate() + (now.getHours() < 14 ? 2 : 3));
    while(d.getDay() === 0 || d.getDay() === 6){ d.setDate(d.getDate() + 1); }
    dEl.textContent = jours[d.getDay()] + ' ' + d.getDate() + ' ' + mois[d.getMonth()];
  }

})();
